// src/data/embossingData.js

import embossing1 from "../assets/embosing/embosingone.jpg";
import embossing2 from "../assets/embosing/embosingtwo.jpg";    
import embossing3 from "../assets/embosing/embosingthree.jpg";

 const embosingStampData = [
  {
    id: 1,
    name: "Embossing Seal",
    category: "Embossing",
    image: embossing1,
    size: "45x45 mm",
    description: "Durable embossing stamp ideal for official documents."
  },
  {
    id: 2,
    name: "Handy Embossing Stamp",
    category: "Embossing",
    image: embossing2,
    size: "35x35 mm",
    description: "High-quality embossing with clear impressions."
  },
  {
    id: 3,
    name: "Embossing Stickers",
    category: "Embossing",
    image: embossing3,
    size: "stickers",
    description: "Elegant embossing tool for certificates and branding."
  }
];

export default embosingStampData;
